export default {
  methods: {
    doesFileExists(url) {
      let http = new XMLHttpRequest();
      if (url !== undefined) {
        http.open("Head", url, false);
        http.send();
        return http.status != 404;
      }
      return http.status == 404;
    },
  },
};
